module.exports = __webpack_public_path__ + "media/site/images/startups/jedziemyrazem-fcc31a62f1d7b1d8ff34e4cfa8d48fc1.png";